export default class Gallery {

	static getHolderSelectors = () => ['.gallery-element'];

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		new LuminousGallery(holderElement.querySelectorAll('a'));
	}

}
